import { ModelConfig } from '@rematch/core';
import { userInfo } from '../../../models/entities/user';
import { localSDK as client } from '../../../sdk';

export type PlatformUsersState = {
    users: userInfo[];
    total: number;
    gridFilter: string;
    lastError: string | null;
};

export const platformUsers: ModelConfig<PlatformUsersState> = {
    state: {
        users: [],
        total: 0,
        gridFilter: '',
        lastError: null
    },
    reducers: {
        setUsers(state, payload: { users: userInfo[]; total: number }) {
            return { ...state, users: payload.users, total: payload.total, lastError: null };
        },
        setGridFilter(state, gridFilter: string) {
            return { ...state, gridFilter };
        },
        setLastError(state, lastError: string | null) {
            return { ...state, lastError };
        }
    },
    effects: (dispatch: any) => ({
        async fetchUsers(filter?: Record<string, string>) {
            try {
                const { data, total } = await client.platformUsers().fetchUsers({
                    range: [0, 499],
                    filter
                });
                dispatch.platformUsers.setUsers({ users: data, total });
            } catch (error: any) {
                dispatch.platformUsers.setLastError(error?.message || 'Failed to load users');
                throw error;
            }
        },
        async saveUser(payload: { id?: string; data: Record<string, unknown> }) {
            try {
                if (payload.id) {
                    await client.platformUsers().updateUser(payload.id, payload.data);
                } else {
                    await client.platformUsers().createUser(payload.data);
                }
                dispatch.platformUsers.setLastError(null);
                await dispatch.platformUsers.fetchUsers();
            } catch (error: any) {
                dispatch.platformUsers.setLastError(error?.message || 'Failed to save user');
                throw error;
            }
        }
    })
};
